import { Injectable } from '@angular/core';
import { InMemoryCacheService } from 'src/app/common/cache/in-memory-cache.service';
import { CoreService } from 'src/app/common/http-services/core.service';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private cache: InMemoryCacheService, private core: CoreService<{}>) { }


  public async getContactByUser(uid: string, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.get(`${environment.identityUrl}/contact/user/${uid}`));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async getUserByRole(role: string, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.get(`${environment.identityUrl}/user/role/${role}`));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async customerSearch(searchString: string, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.get(`${environment.identityUrl}/user/search/${searchString}`));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }

  public async orderSearch(start: string, end: string, status: string, handleError: boolean = false) {
    const response = {data: null, error: null};

    try {
      response.data = await firstValueFrom(this.core.get(`${environment.billingServiceUrl}/concreteOrder/search/${start}/${end}/${status}`));
    } catch (error) {
      response.error = error;
      if (handleError) {
        await this.handleError(error);
      }
    }

    return response;
  }



  private handleError(error: any) {

  }


}
